import { render, staticRenderFns } from "./TreeNodeAttribute.vue?vue&type=template&id=396af80c&scoped=true&lang=pug&"
import script from "./TreeNodeAttribute.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeAttribute.vue?vue&type=script&lang=ts&"
import style0 from "./TreeNodeAttribute.vue?vue&type=style&index=0&id=396af80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396af80c",
  null
  
)

export default component.exports